import { parseBetsData } from "./parseBetsData";
import { parseMacroGruppi } from "./parseMacroGruppi";
import { isCotaOrExtra, parseScore} from "./data";

export function parseMatchData(data, idAggregata, match, isLive, compattaParametriche) {
    match.widgetType = data.wty;
    match.geniusId = data.gid;
    match.lsportWidgetId = data.lswid;
    const matchData = {
        pal: match.pal,
        avv: match.avv,
        id: match.id,
        desc: match.desc,
        uniqueId: match.uniqueId,
        alias: match.alias,
        sportDesc: match.sportDesc,
        tournamentDesc: match.tournamentDesc,
        sportRef : match.sportRef,
        tournamentRef : match.tournamentRef,
        timestamp : match.timestampDB,
        round: data.r,
        widgetType: match.widgetType,
        geniusId: match.geniusId,
        lsportWidgetId: match.lsportWidgetId,
        urlPath: match.urlPath,
        urlPathSeo: match.urlPathSeo,
        urlPathSeoSettings: match.urlPathSeoSettings,
        str : data.str
    };
    let aggs = data.ags;
    if (!window.isCotaExtraEnabled) {
        aggs = aggs.filter(aggId => !isCotaOrExtra(isLive, matchData.sportRef, aggId));
    }
	const betsData = parseBetsData(matchData, aggs, idAggregata, data.scs, isLive, compattaParametriche);
    // if (match.avvRef != null) {
    //     addMatchBets(betsData.bets, match);
    // }
	betsData.giocabilita = data.sh&&data.scs.length>0;
	//match.giocabilita = data.sh&&data.scs.length>0;
	if (data.scr) {
		betsData.score = parseScore(data.scr, match.sportRef);
    }
	
	// Aggiungi i macrogruppi, se esistono
	const macrogruppi = parseMacroGruppi(betsData.gruppoById, match.sportRef, match.isLive);

	return {aggId: idAggregata, ...betsData, macrogruppi, dataUniqueId: isLive ? null : +new Date()};
}
